import {Child} from './Child';
import {ChildProgressLevelTracker} from './ChildProgressLevelTracker';
import {ScopeQuestionareInProgress} from './ScopeQuestionareInProgress';
import {ScopeActivityTrackerInProgress} from './ScopeActivityInProgress';
import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {StringUtils} from '../../utils/string.utils';

export class ProgramDashboard {
    child: Child;
    childProgressLevelTracker: ChildProgressLevelTracker;
    questionareInProgressList: ScopeQuestionareInProgress[];
    activityTrackerInProgressList: ScopeActivityTrackerInProgress[];

    static apimapper(apijsonResult: ApiJsonResult): ProgramDashboard {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = ProgramDashboard.populate(jsonObject);
        }
        return obj;
    }

    static populate(jsonObject: any) {
        const obj = new ProgramDashboard();
        obj.child = jsonObject.child;
        obj.childProgressLevelTracker = jsonObject.childProgressLevelTracker;
        obj.questionareInProgressList = jsonObject.questionareInProgressList;
        obj.activityTrackerInProgressList = jsonObject.activityTrackerInProgressList;
        return obj;
    }
}
